import React from 'react';
import { Edit2, FileText, Trash2 } from 'lucide-react';
import { Dropdown, DropdownContent, DropdownItem } from '../ui';
import { useViewport } from '../../contexts/ViewportContext';

interface TopicItemMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onContext: () => void;
  isAIChat: boolean;
  triggerRef?: React.RefObject<HTMLElement>;
}

export function TopicItemMenu({
  isOpen,
  onClose,
  onEdit,
  onDelete,
  onContext,
  isAIChat,
  triggerRef,
}: TopicItemMenuProps) {
  const { isMobile } = useViewport();

  // Empty trigger since the button is handled by the parent component
  const emptyTrigger = <span style={{ display: 'none' }} />;

  // Handle specific item clicks
  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEdit();
    onClose();
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete();
    onClose();
  };

  const handleContextClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onContext();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Dropdown
      trigger={emptyTrigger}
      open={isOpen}
      onOpenChange={open => {
        if (!open) onClose();
      }}
      width={144} // w-36 in pixels
      isMobile={isMobile}
      position="bottom-right"
      showBackdrop={isMobile}
      mobilePosition={0.2} // Position near the top of the screen
      mobileTitle="Topic Options"
      anchorElement={triggerRef?.current || null}
      contentClassName="bg-white rounded-lg shadow-lg overflow-hidden border-0"
    >
      <DropdownContent>
        {isAIChat && (
          <DropdownItem
            leftIcon={<FileText size={isMobile ? 16 : 14} />}
            onClick={handleContextClick}
            className="text-gray-700 hover:bg-gray-50"
          >
            Context
          </DropdownItem>
        )}

        <DropdownItem
          leftIcon={<Edit2 size={isMobile ? 16 : 14} />}
          onClick={handleEditClick}
          className="text-gray-700 hover:bg-gray-50"
        >
          Edit
        </DropdownItem>

        <DropdownItem
          leftIcon={<Trash2 size={isMobile ? 16 : 14} className="text-red-600" />}
          onClick={handleDeleteClick}
          className="text-red-600 hover:bg-gray-50"
        >
          Delete
        </DropdownItem>
      </DropdownContent>
    </Dropdown>
  );
}
